import { Pipe, PipeTransform } from '@angular/core';
import { ContactBase, User } from '@shared/api/api-loop/models';

@Pipe({
  name: 'displayName',
  standalone: false
})
export class DisplayNamePipe implements PipeTransform {
  transform(contact: ContactBase): string {
    if (!contact) {
      return '';
    }

    if ((<User>contact).displayName) {
      return (<User>contact).displayName;
    } else {
      return contact.name;
    }
  }
}
